// extracted by mini-css-extract-plugin
export default {"actions":"cXESpF","stats":"qBNQFI","date":"n4dgXP"};